import { nextTick } from 'vue'
import { ui } from '@/ui/services'

const install = app => {
  const toast = text => ui.toast.text(text)
  const loading = text => {
    if (text === undefined) nextTick(() => ui.loading.hide())
    else ui.loading.show({ text })
  }
  Object.defineProperties(app.config.globalProperties, {
    $toast: { get: () => toast },
    $loading: { get: () => loading }
  })
}
export default { install }
